import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { globalHistory } from '@reach/router';
import { Arrow, Img, Loader, Neon } from '../../components';
import { Wrapper, Overlay, FeaturedImg, Content } from './Home.styled';

export default function Home({ data }) {
	const { title } = data.site.siteMetadata;
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// https://stackoverflow.com/questions/61274365/allow-component-to-detect-route-change-in-gatsby
		// https://stackoverflow.com/a/61664193
		return globalHistory.listen(({ action }) => {
			if (action === 'PUSH') {
				setLoading(false);
			}
		});
	}, [setLoading]);

	const handleSetLoading = () => {
		setTimeout(() => {
			setLoading(true);
		}, 100);
	};

	return (
		<Wrapper>
			<FeaturedImg>
				<Img
					src={data.file.childImageSharp.gatsbyImageData}
					alt={title}
				/>
			</FeaturedImg>
			<Overlay />
			<Content>
				{loading ? (
					<Loader size="large" />
				) : (
					<Link to="/about" onClick={handleSetLoading}>
						<Neon as="h1" color="flicker">
							{title}
						</Neon>

						<Neon as="p" color="green">
							Enter Here <Arrow />
						</Neon>
					</Link>
				)}
			</Content>
		</Wrapper>
	);
}
